<template>
  <div>
    <Breadcrumb
      v-if="$route.params.slug"
      :key="$route.path"
      :title="$route.params.slug"
    ></Breadcrumb
    >Single Event info here: <br /><br />{{ $route.params.slug }}
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
